import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { fetchLiveCatalogDescription } from '../lib/catalogDescriptionRead'

/**
 * useCatalogDescription — live (founder-approved) AI description for a catalog row.
 * Returns null while loading, on error, or when no live description exists.
 * Query logic lives in src/lib/catalogDescriptionRead.js so it is unit-tested
 * without rendering.
 *
 * @param {string} catalogId - UUID of the catalog row
 * @returns {{ description: string | null, loading: boolean, error: Error | null }}
 */
export function useCatalogDescription(catalogId) {
  const [description, setDescription] = useState(null)
  const [loading, setLoading] = useState(Boolean(catalogId))
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!catalogId) {
      setDescription(null)
      setError(null)
      setLoading(false)
      return undefined
    }
    let isMounted = true
    setLoading(true)
    setError(null)
    fetchLiveCatalogDescription(supabase, catalogId)
      .then(text => {
        if (isMounted) setDescription(text)
      })
      .catch(err => {
        if (isMounted) {
          setError(err)
          setDescription(null)
        }
      })
      .finally(() => {
        if (isMounted) setLoading(false)
      })
    return () => {
      isMounted = false
    }
  }, [catalogId])

  return { description, loading, error }
}
